import { CountryCode, ProjectCode } from '@constants'
import { type ValueOf } from '@dni-types/utilities/value-of'
import { BrandCategory } from './brands'

export const HEADER_HEIGHT = 56
export const BASE_PATH = '/shepherdtech-market' as const
export const DEFAULT_COUNTRY_CODE = CountryCode.TW

interface StmCountryConfig {
  label: string
  defaultCampaignCode: string
  /** 該 country 的代表 projectCode，用來決定 Cosign 元件主題、隱私政策連結、客服連結等 pre-login UI。 */
  defaultProjectCode: ProjectCode
  mallCode: string
}

export const STM_COUNTRY_CONFIG: Partial<Record<CountryCode, StmCountryConfig>> = {
  [CountryCode.TW]: {
    label: '台灣站',
    defaultCampaignCode: 'dcspartnertw',
    defaultProjectCode: ProjectCode.DCS,
    /** Phase 2.1 暫時寫死，未來調整 url 時改成從 url 讀取。 */
    mallCode: '2b-main-tw',
  },
  [CountryCode.HK]: {
    label: '香港站',
    defaultCampaignCode: 'dcspartnerhk',
    defaultProjectCode: ProjectCode.DCS,
    mallCode: '2b-main-hk',
  },
}

export const USER_ROLE = {
  PARTNER: 'partner',
  SHOP_MANAGER: 'shop_manager',
} as const

export type UserRoleType = ValueOf<typeof USER_ROLE>

export const STM_ALLOWED_ROLES = [USER_ROLE.PARTNER, USER_ROLE.SHOP_MANAGER] as const

export const NAV_CATEGORIES: { label: string, category: BrandCategory }[] = [
  { label: '寵食品牌', category: BrandCategory.PET },
  { label: '人食品牌', category: BrandCategory.HUMAN },
]

export const NAV_LINKS: { label: string, to: string }[] = [
  { label: '新品專區', to: '/new-products' },
]
